var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "officeReEdit", staticClass: "officeReEdit" }, [
    _c(
      "div",
      {
        staticClass: "officeContent",
        style: { height: _vm.canvasHeight + "px" },
        attrs: { id: "officeContent" }
      },
      [
        _c(
          "div",
          { staticClass: "office_pdf" },
          [
            _c("zl_pdf", {
              attrs: {
                src:
                  "https://cjddcloudtest.cailian.net/cjdd/resourse/20211210/680D783F1639129253882.pdf"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm.isEdit
          ? _c(
              "div",
              {
                style: {
                  width: _vm.canvasWidth + "px",
                  height: _vm.canvasHeight + "px"
                }
              },
              [
                _c("canvas", {
                  attrs: {
                    id: "officeCanvas",
                    width: _vm.canvasWidth,
                    height: _vm.canvasHeight
                  }
                })
              ]
            )
          : _vm._e()
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "officeTools" }, [
      _c("i", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isEdit,
            expression: "isEdit"
          }
        ],
        staticClass: "el-icon-arrow-up",
        staticStyle: { "font-size": "25px" },
        on: { click: _vm.switchingFunction }
      }),
      _vm._v(" "),
      _c("i", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isEdit,
            expression: "!isEdit"
          }
        ],
        staticClass: "el-icon-arrow-down",
        staticStyle: { "font-size": "25px" },
        on: { click: _vm.switchingFunction }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isEdit,
              expression: "isEdit"
            }
          ],
          staticClass: "fillColor"
        },
        [
          _c("el-color-picker", {
            attrs: { predefine: _vm.predefineColors },
            on: { change: _vm.selectColor },
            model: {
              value: _vm.drawColor,
              callback: function($$v) {
                _vm.drawColor = $$v
              },
              expression: "drawColor"
            }
          }),
          _vm._v(" "),
          _c("el-slider", {
            staticStyle: {
              width: "100px",
              position: "relative",
              left: "45px",
              top: "5px"
            },
            on: { change: _vm.setDrawWidth },
            model: {
              value: _vm.drawWidth,
              callback: function($$v) {
                _vm.drawWidth = $$v
              },
              expression: "drawWidth"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "lines" },
            [
              _vm._l(_vm.toolsArr, function(item, idx) {
                return _c(
                  "div",
                  {
                    key: idx,
                    staticStyle: {
                      "margin-top": "10px",
                      cursor: "pointer",
                      "margin-left": "25px"
                    },
                    on: {
                      click: function($event) {
                        return _vm.handleTools(item)
                      }
                    }
                  },
                  [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: item.label,
                          placement: "bottom",
                          effect: "light"
                        }
                      },
                      [_c("i", { class: item.type })]
                    )
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: "生成图片",
                    placement: "bottom",
                    effect: "light"
                  }
                },
                [
                  _c("i", {
                    staticClass: "iconfont icon-tupian",
                    staticStyle: {
                      position: "relative",
                      top: "10px",
                      left: "25px"
                    },
                    on: {
                      click: function($event) {
                        return _vm.onLoadImage()
                      }
                    }
                  })
                ]
              )
            ],
            2
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d03cf6e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d03cf6e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/officeReEdit.vue
// module id = null
// module chunks = 